import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Output, ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../../crystal-elements/cc-base.component";
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../../../model/api/form-field-group-config";
import {Invoice} from "../../../../../model/billing/invoice";
import {BillingService} from "../../../../../services/billing/billing.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-invoice-update-outstanding-form',
  templateUrl: './update-outstanding-form.component.html',
  styleUrls: ['./update-outstanding-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateOutstandingFormComponent extends CcBaseComponent {

  transPartKey: string = 'billing';

  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  formRecord: Invoice | any;

  loadingProgressValue: number = 100;
  dialogFormVisible: boolean = false;

  @Output()
  onSavedForm = new EventEmitter<any>();

  constructor(cdref: ChangeDetectorRef,
              private billingService: BillingService,
              messageService: MessageService,
              private confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.update_outstanding');
    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'outStandingAmount',
            column: 12,
            type: TYPE.DECIMAL,
            focused: true,
          }]
      }];
  }

  public open(invoice: Invoice): void {
    this.formRecord = invoice;
    this.dialogFormVisible = true;
    this.markForCheck();
  }

  save() {
    this.formLoading = true;

    if (this.formRecord.outStandingAmount === 0) {
      this.confirmationService.confirm({
        header: 'Confirm',
        message: "Invoice will be fully paid. Do you want to continue?",
        icon: 'fas fa-exclamation-triangle',
        acceptLabel: 'Yes',
        acceptButtonStyleClass: 'p-button-success p-button-sm',
        rejectLabel: 'No',
        rejectButtonStyleClass: 'p-button-warning p-button-sm',
        accept: () => {
          this.billingService.updateOutstandingAmount(this.formRecord).subscribe(validation => {
            if (validation.success) {
              this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
              this.closeDialogForm();
            } else {
              this.errorMessage(validation.message);
            }
            this.formLoading = false;
          });
        },
        reject: () => {
        }
      });
    } else {
      this.billingService.updateOutstandingAmount(this.formRecord).subscribe(validation => {
        if (validation.success) {
          this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
          this.closeDialogForm();
        } else {
          this.errorMessage(validation.message);
        }
        this.formLoading = false;
      });
    }
  }

  closeDialogForm(): void {
    this.dialogFormVisible = false;
    this.markForCheck();
  }

}
